import React, { Component } from "react";
import Auxiliary from "../Auxiliary";
import { axios } from "@Services/API/Axios";
import dynamic from "next/dynamic";
const Alert = dynamic(() => import("@mui/material/Alert"), { ssr: false });

interface IState {
  error: null | [];
  open: boolean;
  success: null;
  submit: boolean;
}
const Interceptor = (WrappedComponent: any) => {
  return class extends Component {
    //here withErrorHandler returns an anonymus class which recieves the props of the wrappedComponent.
    state: IState = {
      error: null,
      open: true,
      success: null,
      submit: false,
    };
    reqInterceptors!: number;
    responseInterceptors!: number;

    componentWillMount() {
      this.reqInterceptors = axios.interceptors.request.use((request) => {
        if (request.data && request.data.submit) {
          this.setState({ error: null, submit: true });
          delete request.data.submit;
        }
        this.setState({ error: null });
        return request;
      });
      this.responseInterceptors = axios.interceptors.response.use(
        async (response) => {
          if (typeof window === "undefined" || !this) {
            return response;
          }
          if (
            this.state.submit &&
            (response.config.method === "post" ||
              response.config.method === "patch" ||
              response.config.method === "put")
          ) {
            this.setState({
              success: "Successfully Submited",
              open: true,
              error: null,
            });
            const timeOut = () => {
              return new Promise((resolve) =>
                setTimeout(() => {
                  this.setState({ open: false });
                  resolve(response);
                }, 2000)
              );
            };
            await timeOut();
            this.setState({ submit: false, error: null });
            return response;
          } else {
            return response;
          }
        },

        (error) => {
          this.setState({
            error: error.response.data.errors,
            open: true,
            success: null,
          });
          setTimeout(() => this.setState({ open: false }), 5000);
          // if (error.response.data.errors == "jwt expired") {
          //   const obj = {
          //   }
          //   try {
          //     const response = await Refresh.post!(obj)
          //     if (response) {
          //     }
          //   } catch (err) {
          //     console.log(err);
          //   }
          // }
          throw new Error(error.response.data.errors);
          // return error;
        }
      );
    }
    errorHandler = () => {
      this.setState({ error: null });
    };

    componentWillUnmount() {
      axios.interceptors.request.eject(this.reqInterceptors);
      axios.interceptors.response.eject(this.responseInterceptors);
    }

    onCloseHandler = () => {
      this.setState({ open: false });
    };

    render() {
      return (
        <Auxiliary open>
          {!!this.state.error && this.state.open && (
            <Alert
              onClose={this.onCloseHandler}
              variant="filled"
              severity="error"
              sx={{
                position: "fixed",
                top: { sm: "2px", xs: "3.2rem" },
                right: "5px",
                zIndex: "10000",
                background: "red",
                // textTransform: "capitalize",
                width: "20rem",
              }}
            >
              {this.state.error.map((val: any, index) => {
                return (
                  <span key={index}>
                    <span style={{ textTransform: "uppercase" }}>{val[0]}</span>
                    <span>{val.slice(1)}</span>
                  </span>
                );
              })}
            </Alert>
          )}
          <WrappedComponent {...this.props} />
        </Auxiliary>
      );
    }
  };
};
export default Interceptor;
Interceptor.displayName = "interceptor";
